import { Alert, useThemeProvider } from '@acin/ui-core';
import React from 'react';
import { useRegulation } from '../../RegulationProvider';
import * as SC from './ChooseDocument.styled';

interface ChooseDocumentProps {
  className?: string;
  modalOpened: boolean;
  onUpdateModalOpened: (opened: boolean) => void;
}

export const ChooseDocument: React.FC<ChooseDocumentProps> = (props) => {
  const { modalOpened, onUpdateModalOpened } = props;

  const { activeTheme } = useThemeProvider();
  const { activeDocument, onUpdateShowDocumentModal } = useRegulation();

  React.useEffect(() => {
    if (!activeDocument && !modalOpened) {
      onUpdateShowDocumentModal(true);
      onUpdateModalOpened(true);
    }
  }, [activeDocument, onUpdateShowDocumentModal, modalOpened, onUpdateModalOpened]);

  return (
    <SC.ChooseDocument activeTheme={activeTheme} data-testid="choose-document">
      <Alert status="info" title="Select a document to view its obligations" />
    </SC.ChooseDocument>
  );
};
